import React, { useEffect, useState } from 'react';
import { compose, graphql } from 'react-apollo';
import { getUserData } from 'utils/graphQLFunctions';
import { USER_QUERY } from 'utils/graphql/userQueries';
import UserAvatar from '../index';
import { SET_AVATAR_DATA_MUTATION } from '../mutations/setAvatarDataMutation';
import { avatarKeyMap, getImageWithBackground } from '../utils';
import AvatarSelector from './AvatarSelector';

const SetUpAvatar = props => {
  const [selectedProfileImage, setSelectedProfileImage] = useState('');
  const [editFail, setEditFail] = useState(false);

  useEffect(() => {
    if (
      props.userData &&
      props.userData.user &&
      props.userData.user.avatarData
    ) {
      const selectedAvatarKey = Object.entries(avatarKeyMap).find(
        ([key, value]) => value === props.userData.user.avatarData
      )?.[0];
      setSelectedProfileImage(getImageWithBackground(selectedAvatarKey));
    }
  }, [props.userData]);

  const handleAvatarSelect = avatar => {
    setSelectedProfileImage(avatar);
  };

  const getAvatarValue = () => {
    const fileName = selectedProfileImage.split('/').pop().split('.')[0];
    const avatarValue = avatarKeyMap[fileName];
    return avatarValue || null;
  };

  const handleSetAvatar = async () => {
    const selectedAvatarDataValue = getAvatarValue();
    try {
      await props.setAvatarDataMutation({
        variables: {
          input: {
            avatarData: selectedAvatarDataValue
          }
        },
        update: (cache, { data }) => {
          if (data && data.setAvatarData) {
            setEditFail(false);
            const userData = cache.readQuery({
              query: USER_QUERY
            });

            if (userData) {
              cache.writeQuery({
                query: USER_QUERY,
                data: {
                  user: {
                    ...userData.user,
                    avatarData: selectedAvatarDataValue
                  }
                }
              });
            }
            props.hideEditAvatar();
            props.showSuccessAvatar();
          } else {
            setEditFail(true);
          }
        },
        onError: () => {
          setEditFail(true);
        }
      });
    } catch (e) {
      console.error('failed to update avatar data', e);
      setEditFail(true);
    }
  };

  return (
    <>
      <h2 className="edit-avatar-title">CHOOSE AN AVATAR</h2>
      <div className="edit-avatar-preview">
        <div className="edit-avatar-info">
          <div
            className="edit-avatar-display-name"
            {...(props.userData &&
              props.userData.user &&
              props.userData.user.displayName && {
                title: props.userData.user.displayName
              })}
          >
            {props.userData &&
              props.userData.user &&
              props.userData.user.displayName}
          </div>
          <UserAvatar edit={true} avatarData={getAvatarValue()} />
        </div>
        <div className="edit-avatar-submit">
          <button
            onClick={e => {
              e.preventDefault();
              handleSetAvatar();
            }}
            type="button"
            className="btn btn-success"
            disabled={getAvatarValue() === props.userData.user.avatarData}
          >
            SUBMIT
          </button>
        </div>
      </div>

      {editFail && (
        <h6 className="edit-avatar-error">
          Failed to update avatar. Please try again.
        </h6>
      )}

      <AvatarSelector {...props} onSelect={handleAvatarSelect} />
    </>
  );
};

export default compose(
  graphql(SET_AVATAR_DATA_MUTATION, { name: 'setAvatarDataMutation' }),
  getUserData({
    name: 'userData'
  })
)(SetUpAvatar);
